import jquery from "jquery"
window.$ = jquery
window.jQuery = jquery

console.log("jQuery loaded?", window.jQuery)

import Quill from 'quill'
globalThis.Quill = Quill;